import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We will get back to you soon.');
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact">
      <div className="container">
        {/* Hero Section */}
        <section className="contact-hero">
          <h1>Contact Us</h1>
          <p>Get in touch with the Oromo Gadaa-UK community. We're here to help and answer your questions.</p>
        </section>

        {/* Contact Content */}
        <section className="contact-content">
          <div className="contact-grid">
            
            {/* Contact Form */}
            <div className="contact-form-section">
              <h2>Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a subject</option>
                    <option value="general">General Inquiry</option>
                    <option value="services">Services Information</option>
                    <option value="events">Events & Activities</option>
                    <option value="membership">Membership</option>
                    <option value="volunteer">Volunteer Opportunities</option>
                    <option value="support">Community Support</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn">Send Message</button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="contact-info-section">
              <h2>Get in Touch</h2>
              
              <div className="contact-methods">
                <div className="contact-method">
                  <h3>Office Address</h3>
                  <p>
                    Oromo Gadaa-UK Community Center<br/>
                    127 Dean Road<br/>
                    Bolton BL3 5AG<br/>
                    Greater Manchester<br/>
                    United Kingdom
                  </p>
                </div>

                <div className="contact-method">
                  <h3>Phone & Email</h3>
                  <p>
                    <strong>Main Office:</strong> +44 7493193493<br/>
                    <strong>Email:</strong> info@gadaauk.com<br/>
                    <strong>Services:</strong> services@gadaauk.com
                  </p>
                </div>

                <div className="contact-method">
                  <h3>Office Hours</h3>
                  <p>
                    <strong>Monday:</strong> 10:00 AM - 2:00 PM<br/>
                    <strong>Wednesday:</strong> 10:00 AM - 2:00 PM<br/>
                    <strong>Friday:</strong> 10:00 AM - 2:00 PM
                  </p>
                </div>

                <div className="contact-method">
                  <h3>Social Media</h3>
                  <p>
                    Follow us on social media for updates and community news:<br/>
                    <strong>Facebook:</strong> @OromoGadaaUK<br/>
                    <strong>Twitter:</strong> @GadaaUK<br/>
                    <strong>Instagram:</strong> @oromogadaauk
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>




      </div>
    </div>
  );
};

export default Contact;
